import type { NavigationItemInterface } from '@hypercodestudio/basler-components';

import { isDefined } from '~/utils/guards/isDefined';
import { isVisible } from '~/utils/entry/isVisible';
import type { SecondaryNavigationItemSource } from '~/types/MinifiedSecondaryNavigation';
import { isEntryOfContentType } from '~/utils/guards/isEntryOfContentType';
import { getLinkIconPosition } from '~/utils/getLinkIconPosition';

function getNavigationLinkIconFields(item: SecondaryNavigationItemSource) {
  const externalLink = item.fields?.externalLink;
  if (!externalLink || !isEntryOfContentType(externalLink, 'link')) {
    return {};
  }

  const linkIcon = externalLink.fields?.linkIcon;
  if (!linkIcon) {
    return {};
  }

  return {
    iconName: linkIcon,
    iconType: getLinkIconPosition(
      externalLink.fields?.linkIconPosition as 'left' | 'right' | undefined
    )
  };
}

export function useCreateSecondaryNavItem(
  item: SecondaryNavigationItemSource | null | undefined
): NavigationItemInterface | undefined {
  if (!item || !isVisible(item)) {
    return;
  }

  return {
    items: item.fields?.navigationItems
      ?.map((item) => useCreateSecondaryNavItem(item))
      .filter(isDefined),
    text: item.fields?.linkText ?? '',
    link:
      item.fields?.internalPage || item.fields?.externalLink
        ? {
            ...useBuildLinkInterface(item),
            ...getNavigationLinkIconFields(item)
          }
        : undefined
  } satisfies NavigationItemInterface;
}
